import React, { Fragment, useState } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import * as Yup from 'yup';
import { pt } from 'yup-locale-pt';

import { makeStyles } from '@material-ui/core/styles';
import { Formik } from 'formik';

import {
    Select,
    InputLabel,
    MenuItem,
    FormControl,
    Box,
    Grid,
    colors,
    Typography,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    Button,
    TextField,
    Switch
} from '@material-ui/core';

Yup.setLocale(pt);

const useStyles = makeStyles((theme) => ({
    root: {
    },
    avatar: {
        marginRight: theme.spacing(2),
        backgroundColor: colors.grey[200]
    },
    fieldset: {
        minWidth: 950,
        maxWidth: 950
    }
}));

const Create = ({ item, open, closeCreation, createValues, dependencies, vision }) => {
    
    const classes = useStyles();
    
    const showErrors = (errors) => {
        console.error(errors);
    }

    return (
        <Fragment>

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="lg" className={classes.root} >
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Novo Contrato de Manutenção
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Formik
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({
                                numero: Yup.string().max(20).required('O número do contrato é obrigatório'),
                                nome: Yup.string().max(100).required('O nome do contrato é obrigatório'),
                                EMPRESA: Yup.string().required('O cliente do contrato é obrigatório')
                            })
                        }
                        onSubmit={(values, formik) => {
                            createValues(values);
                            formik.setSubmitting(false);
                        }}

                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (
                            <form onSubmit={handleSubmit}>

                                <div>{showErrors(errors)}</div>

                                <Box className={classes.fieldset} >

                                    <Grid
                                        container
                                        spacing={2}
                                        xs="auto"
                                    >
                                        <Grid
                                            item
                                            md={2}
                                            xs={2}>

                                            <TextField
                                                error={Boolean(touched.numero && errors.numero)}
                                                fullWidth
                                                required
                                                label="Número"
                                                margin="normal"
                                                name="numero"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.numero}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={4}
                                            xs={4}>

                                            <TextField
                                                error={Boolean(touched.nome && errors.nome)}
                                                fullWidth
                                                required
                                                label="Nome"
                                                margin="normal"
                                                name="nome"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.nome}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={4}
                                            xs={4}>

                                            <FormControl variant="outlined" fullWidth margin="normal">
                                                <InputLabel shrink htmlFor="equipe" required >Cliente</InputLabel>
                                                <Select notched
                                                    autosize={true}
                                                    required
                                                    error={Boolean(touched.EMPRESA && errors.EMPRESA)}
                                                    helperText={touched.EMPRESA && errors.EMPRESA}
                                                    value={values.EMPRESA}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Cliente *"
                                                    variant="outlined"
                                                    inputProps={{
                                                        name: 'EMPRESA',
                                                        id: 'EMPRESA',
                                                    }}
                                                >
                                                    <MenuItem value={null}>
                                                        <em>Selecione uma das opções abaixo</em>
                                                    </MenuItem>
                                                    {dependencies.companies.map((empresa) => (
                                                        <MenuItem key={empresa.id} value={empresa.id}>{empresa.nome}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>

                                        </Grid>

                                        <Grid
                                            item
                                            md={2}
                                            xs={2}>
                                            <Typography
                                                color="textPrimary"
                                                gutterBottom
                                                variant="h6"
                                            >
                                                Ativo
                                            </Typography>
                                            <Switch
                                                checked={values.ativo}
                                                onChange={handleChange}
                                                name="ativa" />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                        >
                                            <TextField
                                                error={Boolean(touched.descricao && errors.descricao)}
                                                fullWidth
                                                helperText="Coloque aqui descrições relacionadas ao contrato (512 caracteres)."
                                                label="Descrição do Contrato"
                                                rows={2}
                                                size={10}
                                                length={512}
                                                multiline
                                                margin="none"
                                                name="descricao"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.descricao}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </Grid>

                                    </Grid>

                                </Box>

                                <Box my={1}></Box>
                                <Divider />

                                <Box my={1}>
                                    <Grid container
                                        direction="row"
                                        justify="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                type="submit"
                                                variant="contained">
                                                Salvar
                                            </Button>
                                        </Grid>
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closeCreation() }}>
                                                Cancelar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </form>
                        )}
                    </Formik>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default Create;
